// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".name-capture[data-v-b39ee906] {\n  position: relative;\n  max-width: 450px;\n}\n.person-icon[data-v-b39ee906] {\n  margin: -22px;\n}\n.profile-photo[data-v-b39ee906] {\n  border-radius: 50%;\n}\nbutton[data-v-b39ee906]:disabled {\n  background: var(--v-accentPurpleTransparent-base);\n  filter: none !important;\n  opacity: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
